import React, { FC } from 'react';

type AppRowProps = {
    className?: string
    children?: React.ReactNode;
}

const AppRow: FC<AppRowProps> = (props) => {
  return (
    <div className={`row ${props.className}`}>
      { props.children }
    </div>
  );
};


export default AppRow;
